import ControllerWithSignal from '../scripts/controller-with-signal';

export default class extends ControllerWithSignal {
  async connectWithSignal(signal) {
    const { Swiper, swiperModules } = await import('../scripts/swiper');
    this.element.dataset.loaded = 'true';
    if (signal.aborted) return;

    this.swiper = new Swiper(this.element, {
      modules: swiperModules,

      pagination: {
        el: '.swiper-pagination',
      },

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      autoplay: {
        delay: 15_000,
        disableOnInteraction: false,
      },
    });
  }

  disconnectWithSignal() {
    this.swiper?.destroy();
  }
}
